var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import env from 'config/env';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var LocationsRepository = /** @class */ (function (_super) {
    __extends(LocationsRepository, _super);
    function LocationsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = String;
        _this.url = 'v4/companies/:companyId/jobs/cities';
        _this.baseUrl = env.JOBILLA_API_ROOT;
        return _this;
    }
    LocationsRepository.prototype.getCities = function (companyId) {
        return this.get(this.url, { companyId: companyId });
    };
    return LocationsRepository;
}(AbstractRepository));
export { LocationsRepository };
